






















import Vue, { VNodeData, PropType } from 'vue';
import AProgressCircular from '@/components/AProgressCircular.vue';

const DESIGNS = ['primary', 'secondary', 'tertiary'] as const;
type Design = typeof DESIGNS[number];
const SIZES = ['small', 'medium', 'large'] as const;
type Size = typeof SIZES[number];

export default Vue.extend({
  name: 'AButton',
  components: {
    AProgressCircular,
  },
  inheritAttrs: false,
  props: {
    design: {
      type: String as PropType<Design>,
      validator: (value: Design) => DESIGNS.includes(value),
      default: 'primary',
    },
    size: {
      type: String as PropType<Size>,
      validator: (value: Size) => SIZES.includes(value),
      default: 'medium',
    },
    tag: { type: String, default: 'button' },
    outlined: Boolean,
    plain: Boolean,
    reversed: Boolean,
    loading: Boolean,
  },
  computed: {
    mergedAttrs(): VNodeData['attrs'] {
      return {
        type: this.tag === 'button' ? 'button' : undefined,
        ...this.$attrs,
      };
    },
    hasText(): boolean {
      return Boolean(this.$slots.default);
    },
    classes(): VNodeData['class'] {
      return [
        `button_design_${this.design}`,
        `button_size_${this.size}`,
        {
          button_transparent: this.outlined || this.plain,
          button_outlined: this.outlined,
          button_plain: this.plain,
          button_reversed: this.reversed,
          'button_has-no-text': !this.hasText,
          button_loading: this.loading,
        },
      ];
    },
  },
});
